import type { Stocker2DFoupKind, Stocker2DStatus } from './types';

/** Stocker 2D palette — sampled from the STK-01 reference + OHT design system. */
export const STOCKER_2D_COLORS = {
  outline: '#26354A',
  body: '#F3F4F6',
  bodyLight: '#F8FAFC',
  inset: '#E8EAED',
  accent: '#94A3B8',
  accentBlue: '#94A3B8',
  tray: '#374151',
  /** Empty shelf stays dark; a rack slot takes colour only once occupied. */
  slotShelf: '#374151',
  slotEmpty: '#4B5563',
  slotBorder: '#9CA3AF',
  /** 2D carriers in stocker: single unified color. */
  foupRaw: '#00CCFF',
  foupRawBorder: '#0369A1',
  foupProcessed: '#00CCFF',
  foupProcessedBorder: '#0369A1',
  available: '#94A3B8',
  moving: '#94A3B8',
  busy: '#94A3B8',
  error: '#94A3B8',
  offline: '#94A3B8',
  selection: '#2563EB',
  hover: '#93C5FD',
  label: '#26354A',
  capacity: '#6B7280',
} as const;

export const STOCKER_2D_STATUS: Record<Stocker2DStatus, string> = {
  available: STOCKER_2D_COLORS.available,
  moving: STOCKER_2D_COLORS.moving,
  busy: STOCKER_2D_COLORS.busy,
  error: STOCKER_2D_COLORS.error,
  offline: STOCKER_2D_COLORS.offline,
};

export const STOCKER_2D_DEFAULT_WIDTH = 8;
export const STOCKER_2D_DEFAULT_HEIGHT = 15;
export const STOCKER_2D_DEFAULT_ROWS = 14;
export const STOCKER_2D_DEFAULT_COLUMNS = 2;
export const STOCKER_2D_SIMPLE_ZOOM = 0.4;

export function resolveStockerStatusColor(status: Stocker2DStatus = 'available'): string {
  return STOCKER_2D_STATUS[status] ?? STOCKER_2D_STATUS.available;
}

/** Fill + border for a FOUP sitting in a rack slot (single unified color). */
export function resolveStockerFoupColors(_kind?: Stocker2DFoupKind): {
  fill: string;
  stroke: string;
} {
  return { fill: STOCKER_2D_COLORS.foupRaw, stroke: STOCKER_2D_COLORS.foupRawBorder };
}
